import React from 'react';
import { Search } from 'lucide-react';
import Input from '../ui/Input';

/**
 * Search + filter chips for the AccountManager Terminal (industry-standard
 * ops dashboard pattern, plan F11). Filters apply client-side to the loaded
 * snapshot — no extra backend roundtrips. Chip state is owned by the parent
 * page; this is a presentation component.
 */
export interface TerminalFilters {
  search: string;
  onlineOnly: boolean;
  hasPositions: boolean;
}

interface Props {
  filters: TerminalFilters;
  onChange: (next: TerminalFilters) => void;
}

const TerminalFilterBar: React.FC<Props> = ({ filters, onChange }) => {
  const chip = (active: boolean) =>
    `px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${
      active
        ? 'bg-blue-600 text-white border-blue-600 dark:bg-blue-500 dark:border-blue-500'
        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600'
    }`;

  return (
    <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" />
          <Input
            value={filters.search}
            onChange={(e) => onChange({ ...filters, search: e.target.value })}
            placeholder="Search user, basket, or client ID…"
            className="pl-9 w-full"
          />
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onChange({ ...filters, onlineOnly: !filters.onlineOnly })}
            className={chip(filters.onlineOnly)}
          >
            Online only
          </button>
          <button
            type="button"
            onClick={() => onChange({ ...filters, hasPositions: !filters.hasPositions })}
            className={chip(filters.hasPositions)}
          >
            Has positions
          </button>
        </div>
      </div>
    </div>
  );
};

export default TerminalFilterBar;
